/** Leads & inquiries (/w/:ws/leads/:leadId?), engage group. */
export const leads = {
  title: "Leads & inquiries",
  subtitle: "People who shared their contact details with the assistant. Follow up before they go elsewhere.",
  leadFormFields: "Lead form fields",
  exportCsv: "Export CSV",
  exported: "Exported leads · {{file}}",
  exportNoPermission: "Exporting leads needs the export permission.",
  syncToCrm: "Sync to CRM",
  crm: {
    google_sheets: "Google Sheets",
    hubspot: "HubSpot",
    zoho: "Zoho CRM",
    connected: "Connected · auto-sync every 15 min",
    notConnected: "Not connected",
    other: "Webhook & other integrations",
    synced_one: "Synced {{count}} lead to {{provider}}",
    synced_other: "Synced {{count}} leads to {{provider}}",
    failed: "{{provider}} isn't connected yet. Connect it under integrations first.",
    reconnectNeeded: "Reconnect needed",
    needsReconnect: "{{provider}} needs to be connected again",
    openIntegrations: "Open Integrations",
    partial: "{{synced}} synced, {{failed}} not accepted by {{provider}} (edit them and sync again)",
  },
  editStages: "Pipeline stages",
  stats: {
    thisWeek: "Leads this week",
    deltaUp: "+{{count}} vs last week",
    deltaDown: "{{count}} vs last week",
    deltaFlat: "Same as last week",
    topChannel: "From {{channel}}",
    noChannel: "By channel",
    channelSplit: "{{channels}}",
    noLeadsYet: "No leads yet",
    wonRate: "Lead → won",
    wonHint: "Leads that reached a won stage",
    firstFollowUp: "Avg first follow-up",
    hours: "{{value}} h",
    waiting_one: "{{count}} lead waiting > 24 h",
    waiting_other: "{{count}} leads waiting > 24 h",
    noneWaiting: "No leads waiting > 24 h",
  },
  view: {
    label: "View",
    table: "Table",
    board: "Board",
    bookings: "Bookings",
  },
  stageFilter: "Filter by stage",
  all: "All",
  search: "Search name, email, interest…",
  interest: "Interest",
  allInterests: "All interests",
  columns: {
    name: "Name · email",
    mobile: "Phone",
    interest: "Interest",
    source: "Source",
    conversation: "Conversation",
    owner: "Assigned",
    stage: "Stage",
    created: "Created",
  },
  unassigned: "Unassigned",
  stageLabel: "Stage for {{name}}",
  movedTo: "{{name}} moved to {{stage}}",
  idle: "Idle > 24 h",
  idleHint: "No follow-up in more than 24 hours",
  openLead: "Open {{name}}",
  showing: "Showing {{shown}} of {{total}}",
  emptyTitle: "No leads in this stage",
  emptyBody: "When the assistant captures contact details, they show up here.",
  emptyFiltered: "Try another stage or clear your search.",
  clearFilters: "Clear filters",
  loadError: "Leads couldn't load.",
  footnote:
    "Lead data is collected with consent under your privacy notice. Visitors see the privacy notice before submitting the lead form. Phone numbers are partially masked for staff without the export permission.",
  board: {
    label: "Pipeline board",
    column: "{{stage}} · {{count}} leads",
    empty: "No leads",
    moveTo: "Move to…",
    moveMenu: "Move {{name}}",
    dragHint: "Drag a card to another stage, or focus a card and press Alt + ← / → to move it.",
    moved: "{{name}} moved to {{stage}}",
    more: "+{{count}} more in this stage",
  },
  sheet: {
    via: "{{interest}} · via {{channel}}",
    call: "Call",
    sendEmail: "Send email",
    openConversation: "Open conversation",
    mobile: "Phone",
    email: "Email",
    learner: "Details",
    interest: "Interest",
    preferredContact: "Preferred contact",
    consent: "Consent",
    noConsent: "Not recorded",
    created: "Captured",
    owner: "Assigned to",
    stage: "Stage",
    summaryTitle: "Conversation summary · generated by AI",
    noSummary: "No summary yet. Generate one from the conversation.",
    intent: "Likely intent: {{intent}}.",
    nextStep: "Suggested next step: {{step}}",
    regenerate: "Regenerate",
    summaryFailed: "The summary couldn't be generated right now.",
    activity: "Activity",
    notes: "Notes",
    notePlaceholder: "Add a note for the team…",
    noteLabel: "New note",
    addNote: "Add",
    noteRequired: "Write a note first",
    noteAdded: "Note added",
    noNotes: "No notes yet.",
    stageUpdated: "Stage updated to {{stage}}",
    assigned: "Assigned to {{name}}",
    unassignedToast: "Lead unassigned",
    loadError: "This lead couldn't load.",
    notFound: "That lead doesn't exist anymore.",
    customFields: "Lead form answers",
    readOnly: "You can view this lead but not change it.",
  },
  activityType: {
    created: "Lead captured",
    createdVia: "Lead captured via {{channel}}",
    stage_changed: "Stage → {{to}}",
    assigned: "Assigned to {{name}}",
    unassigned: "Unassigned",
    note: "Note added",
    call: "Call logged",
    email: "Email logged",
    sms: "SMS logged",
    summary: "AI summary generated",
    synced: "Synced to CRM",
    other: "Activity",
    by: "by {{name}}",
    system: "System",
  },
  stagesDialog: {
    title: "Pipeline stages",
    description: "Rename, reorder and flag the stages leads move through. Keep at least one won and one lost stage.",
    name: "Stage {{n}} name",
    won: "Won",
    lost: "Lost",
    outcome: "Outcome for {{name}}",
    open: "Open",
    moveUp: "Move {{name}} up",
    moveDown: "Move {{name}} down",
    remove: "Remove {{name}}",
    add: "Add stage",
    newStage: "New stage",
    leads_one: "{{count}} lead",
    leads_other: "{{count}} leads",
    reassign: "Move its leads to",
    reassignLabel: "Move leads from {{name}} to",
    reassignRequired: "Choose where the leads of “{{name}}” go.",
    needWon: "Keep at least one won stage.",
    needLost: "Keep at least one lost stage.",
    nameRequired: "Every stage needs a name.",
    duplicate: "Stage names must be unique.",
    tooFew: "Keep at least {{count}} stages.",
    tooMany: "At most {{count}} stages.",
    save: "Save stages",
    saved: "Pipeline stages saved",
    conflict: "A removed stage still has leads. Choose where to move them.",
    noPermission: "Editing stages needs workspace management permission.",
  },
};
